<template>
	<li>
		<b-input-group>
			<b-input-group-prepend v-if="target=='link'">
				<b-input-group-text>Custom Link</b-input-group-text>
			</b-input-group-prepend>
			<input class="form-control" v-model="spell.Name" v-if="target=='name'"/>
			<input class="form-control" v-model="spell.Link" v-if="target=='link'"/>
			<b-input-group-append>
				<b-button variant="outline-secondary" v-if="target=='name'" @click="target='link'">
					<font-awesome-icon icon="link"></font-awesome-icon>
				</b-button>
				<b-button variant="outline-secondary" v-if="target=='link'" @click="target='name'">
					<font-awesome-icon icon="save"></font-awesome-icon>
				</b-button>
			</b-input-group-append>
		</b-input-group>
	</li>
</template>

<script>
export default {
	data: function(){
		return {
			target: 'name',
		}
	},
	props: [
		'level',
		'spellLevel',
		'listIndex',
	],
	computed: {
		spell: function() {
			var spells = this.$store.state.Character.Levels[this.level].Spells
			var spellList = spells.List
			var spellLevel = spellList[this.spellLevel]
			var spell = spellLevel[this.listIndex]
			return (spell === undefined) ? {Name:"",Link:""} : spell
		}
	},
	watch: {
		spell: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].Spells.List[${this.spellLevel}][${this.listIndex}]`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>

</style>